import { delayed } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';

const kUseIframe = false;

export const useSharePdf = (_filename: string) => {
  return usePersistFn(async (url: string) => {
    if (kUseIframe) {
      const iframe = document.createElement('iframe');

      iframe.src = url;
      iframe.name = 'pdf';
      iframe.hidden = true;
      iframe.style.display = 'none';

      // call the print method in the iframe onload handler
      iframe.onload = () => {
        // todo: solve security issues here.
        // Blocked a frame with origin from accessing a cross-origin frame.
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
        delayed(() => {
          document.body.removeChild(iframe);
        }, 10000);
      };
      document.body.appendChild(iframe);
    } else {
      const link = document.createElement('a');
      // link.download = encodeURIComponent(filename);
      link.href = url;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      delayed(() => {
        document.body.removeChild(link);
      }, 0);
    }
  });
};
